import { render, staticRenderFns } from "./ShortAnswerActive.vue?vue&type=template&id=257cc72f&scoped=true&"
import script from "./ShortAnswerActive.vue?vue&type=script&lang=js&"
export * from "./ShortAnswerActive.vue?vue&type=script&lang=js&"
import style0 from "./ShortAnswerActive.vue?vue&type=style&index=0&id=257cc72f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257cc72f",
  null
  
)

export default component.exports